import { PhoneForwarded } from "@material-ui/icons";

export default [
    {
        id: 0,
        name: "Transfer To",
        icon: <PhoneForwarded></PhoneForwarded>,
    },
];